import { IEnv } from "../interface/util";

export enum IConfigLogLevel {
    Undef       = 0,
    Milestone   = 1,
    Trace       = 2,
    Verbose     = 3,
    Info        = 4,
    Warn        = 5,
    Error       = 6,
    Fatal       = 7,
    LastValue   = 8,
}

export enum IConfigLogDestination {
    Undef = 0,
    Console = 1,
    Remote_ApplicationInsights = 2,
    LastValue = 3,
}

export interface IConfigLogSettings {
    authorizationKey?: string;
}

export interface IConfigLog {
    loggingLevelsEnabled: Array<IConfigLogLevel>;
    outputDestinations: Array<IConfigLogDestination>;
    outputConfiguration: Record<IConfigLogDestination.Console | IConfigLogDestination.Remote_ApplicationInsights,IConfigLogSettings>;
}


const DEFAULTS = {
    LOGGINGLEVELSENABLED: [IConfigLogLevel.Trace, IConfigLogLevel.Info, IConfigLogLevel.Warn, IConfigLogLevel.Error, IConfigLogLevel.Fatal, ],
    OUTPUTDESTINATIONS: [IConfigLogDestination.Console],
    OUTPUTCONFIGURATION: {
        [IConfigLogDestination.Console]: {},
        [IConfigLogDestination.Remote_ApplicationInsights]: {},
    }
}

function config(env: IEnv): IConfigLog {
    const config: IConfigLog = {
        loggingLevelsEnabled:   env.getValueWithDefault<Array<IConfigLogLevel>>('REACT_APP_LOG_LEVELS',                             DEFAULTS.LOGGINGLEVELSENABLED),
        outputDestinations:     env.getValueWithDefault<Array<IConfigLogDestination>>('REACT_APP_LOG_DESTINATIONS',                 DEFAULTS.OUTPUTDESTINATIONS),
        outputConfiguration:    env.getValueWithDefault<Record<IConfigLogDestination.Console | IConfigLogDestination.Remote_ApplicationInsights,IConfigLogSettings>>('REACT_APP_LOG_SETTINGS', DEFAULTS.OUTPUTCONFIGURATION),
    }

    return config;
}

export default config
